import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"
import { SequenceAnimator } from "react-sequence-animator"
import { cardSize } from "helpers/constants_helper"

import { isIOS, isAndroid } from "react-device-detect"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

//card animation
import front01 from "assets/images/ugifts/cardFront/front01.png"
import front02 from "assets/images/ugifts/cardFront/front02.png"
import front03 from "assets/images/ugifts/cardFront/front03.png"
import front04 from "assets/images/ugifts/cardFront/front04.png"
import front05 from "assets/images/ugifts/cardFront/front05.png"
import front06 from "assets/images/ugifts/cardFront/front06.png"
import front07 from "assets/images/ugifts/cardFront/front07.png"
import front08 from "assets/images/ugifts/cardFront/front08.png"
import front09 from "assets/images/ugifts/cardFront/front09.png"
import front10 from "assets/images/ugifts/cardFront/front10.png"
import front11 from "assets/images/ugifts/cardFront/front11.png"
import front12 from "assets/images/ugifts/cardFront/front12.png"
import front13 from "assets/images/ugifts/cardFront/front13.png"

import back0 from "assets/images/ugifts/cardFront/empty.png"
import back10 from "assets/images/ugifts/cardFront/back10.png"
import cardBg from "assets/images/ugifts/cardFront/card_bg.png"

//empty state
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_basket.png"
import emptyWechat from "assets/images/ugifts/icons/empty/empty_wechat.png"

import receiveCard from "assets/images/ugifts/receive_card.png"
import placeholderCamera from "assets/images/ugifts/dummyCard/placeholder_camera.png"
import { SpanRecorder } from "@sentry/tracing/dist/span"
import { spawn } from "redux-saga/effects"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const sequence = [
  {
    front: front01,
    back: back0,
    showed: false,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front02,
    back: back0,
    showed: false,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front03,
    back: back0,
    showed: false,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front04,
    back: back0,
    showed: false,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front05,
    back: back0,
    showed: true,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front06,
    back: back0,
    showed: true,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front07,
    back: back0,
    showed: true,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front08,
    back: back0,
    showed: true,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front09,
    back: back0,
    showed: true,
    top: "48%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front10,
    back: back10,
    showed: true,
    top: "38%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front11,
    back: back10,
    showed: true,
    top: "28%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front12,
    back: back10,
    showed: true,
    top: "18%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: front13,
    back: back10,
    showed: true,
    top: "8%",
    left: "34.67%",
    width: "30%",
  },
  {
    front: back0,
    back: back0,
    showed: true,
    top: "8%",
    left: "29.67%",
    width: "40%",
  },
  {
    front: back0,
    back: back0,
    showed: true,
    top: "8%",
    left: "24.67%",
    width: "50%",
  },
  {
    front: back0,
    back: back0,
    showed: true,
    top: "8%",
    left: "19.67%",
    width: "60%",
  },
  {
    front: back0,
    back: back0,
    showed: true,
    top: "8%",
    left: "14.67%",
    width: "70%",
  },
  {
    front: back0,
    back: back0,
    showed: true,
    top: "8%",
    left: "9.67%",
    width: "80%",
  },
  {
    front: back0,
    back: back0,
    showed: true,
    top: "8%",
    left: "4.67%",
    width: "90%",
  },
]

const useAudio = url => {
  const [audio, setAudio] = useState(null)
  const [playing, setPlaying] = useState(false)

  const toggle = () => setPlaying(!playing)
  const updateAudio = url => {
    audio && audio.pause()
    setPlaying(false)
    setAudio(new Audio(url))
  }

  const playAudio = () => {
    audio && audio.play()
    setPlaying(true)
  }

  const stopAudio = () => {
    audio && audio.pause()
    setPlaying(false)
  }

  useEffect(() => {
    console.log(playing)
    audio && (playing ? audio.play() : audio.pause())
  }, [playing])

  useEffect(() => {
    console.log(audio)
    if (audio) {
      audio.addEventListener("ended", () => setPlaying(false))
      playAudio()
    }

    return () => {
      if (audio) {
        audio.removeEventListener("ended", () => setPlaying(false))
      }
    }
  }, [audio])

  return [playing, toggle, updateAudio, stopAudio]
}

// const cardSize = { width: 1200, height: 800 }

function isWechat() {
  if (
    navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ||
    typeof navigator.wxuserAgent !== "undefined"
  ) {
    return true
  } else return false
}

function hexToBytes(hex) {
  const bytes = new Uint8Array(hex.length / 2)
  for (let i = 0; i !== bytes.length; i++) {
    bytes[i] = parseInt(hex.substr(i * 2, 2), 16)
  }
  return bytes
}

const CardShare = props => {
  const query = useQuery()
  const history = useHistory()
  const isWechatBrowser = isWechat()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [oid, setOid] = useState(null)

  const animRef = useRef(null)
  const animCardRef = useRef(null)
  const animBackRef = useRef(null)

  useEffect(() => {
    console.log("Ref", animRef)
  }, [animRef])

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (query.get("id")) {
      setOid(query.get("id"))
      console.log(Buffer.from(query.get("id")).toString("base64"))
      console.log(
        Buffer.from(
          Buffer.from(query.get("id")).toString("base64"),
          "base64"
        ).toString("ascii")
      )
    }

    // if (isWechatBrowser) {
    //   seterror_alert_static(true)
    //   setdynamic_title("Wechat Browser Detected")
    //   setdynamic_description(
    //     "Please browse this page using your phone's browser"
    //   )
    // }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getOrderData()
      getMusicList()
      console.log("use effect")
    }
  }, [token])

  const [giftcardId, setGiftcardId] = useState(null)
  const [orderData, setOrderData] = useState(null)
  const [giftEditableData, setGiftEditableData] = useState(null)
  const getOrderData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_order")
    urlencoded.append("order_id", oid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request order", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setOrderData(postresponse.table)
      if (postresponse.table.giftcard_id) {
        setGiftcardId(postresponse.table.giftcard_id)
        if (postresponse.table.giftcard_id == "0") {
          setRedeemed(true)
        }
      }
      if (
        postresponse.table.giftcard_edit_parameter &&
        postresponse.table.giftcard_edit_parameter != ""
      ) {
        const download = JSON.parse(postresponse.table.giftcard_edit_parameter)
        download
          .filter(data => {
            return (
              data.type == "message" ||
              data.type == "text" ||
              data.type == "custom_text"
            )
          })
          .forEach(data => {
            data["content"] = new TextDecoder().decode(
              hexToBytes(data["content"])
            )
          })
        setGiftEditableData(download)
        console.log(download)
        // setGiftEditableData(
        //   JSON.parse(postresponse.table.giftcard_edit_parameter)
        // )
        // console.log(JSON.parse(postresponse.table.giftcard_edit_parameter))
      }
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) getGiftList()
  }, [giftcardId])

  const [giftData, setGiftData] = useState(null)
  const getGiftList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_giftcard")
    // urlencoded.append("order_by", sortType)
    urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard product", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [musicData, setMusicData] = useState(null)
  const getMusicList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_music")
    urlencoded.append("order_by", "asc")
    // urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard music", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setMusicData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [redeemed, setRedeemed] = useState(false)
  const [animationPlaying, setAnimationPlaying] = useState(false)

  const onClickRedeemOrder = async () => {
    if (!uid) {
      return
    }

    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "redeem_order")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_id", oid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request redeem order", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200 && postresponse.success) {
      // history.push("/tables-applicationtable")
      // setUserData(postresponse.table)
      // setsuccess_dlg(true)
      // setdynamic_title("Redeem success")
      // setdynamic_description(postresponse.message)
      if (playing) {
        console.log("playing")
        stopAudio()
      }
      history.push("/order-received")
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Redeem Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [redirect, setRedirect] = useState(false)
  function onRedirectNotLogin() {
    setRedirect(true)
    setredirect_alert(true)
    setdynamic_title(props.t("Login to redeem"))
    setdynamic_description(props.t("Will redirect to app/appstore"))
  }

  var fallbackToStore = function () {
    if (isIOS) {
      window.open("https://apps.apple.com/us/app/ugift-global/id1603585098")
    }

    if (isAndroid) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.ebuy.ugift"
      )
    }
  }

  var openApp = function () {
    // window.location.replace("ugift://RedeemGift/?id=" + oid)
    window.open("ugift://RedeemGift/?id=" + oid)
  }

  var triggerAppOpen = function () {
    openApp()
    // setTimeout(fallbackToStore, 700)
  }

  function onRedeemAtAppClicked() {
    triggerAppOpen()
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [error_alert_static, seterror_alert_static] = useState(false)
  const [redirect_alert, setredirect_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  const [playing, toggle, updateAudio, stopAudio] = useAudio()

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  if (playing) {
                    console.log("playing")
                    stopAudio()
                  }
                  history.push("/order-received")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert_static ? (
              <SweetAlert
                title={dynamic_title}
                info
                onConfirm={() => {
                  // seterror_alert(false)
                }}
                onCancel={() => {}}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {redirect_alert ? (
              <SweetAlert
                title={dynamic_title}
                onCancel={() => {
                  setredirect_alert(false)
                }}
                customButtons={<React.Fragment></React.Fragment>}
              >
                <React.Fragment>
                  <Row className="px-3 py-2">
                    <button
                      className="btn btn-primary waves-effect waves-light font-size-15 me-2"
                      onClick={() => {
                        setredirect_alert(false)
                        if (redirect)
                          if (playing) {
                            console.log("playing")
                            stopAudio()
                          }
                        history.push("/login?type=redirect&id=" + oid)
                      }}
                    >
                      {props.t("Login")}
                    </button>
                  </Row>
                  <Row className="px-3 py-2">
                    <button
                      className="btn btn-danger waves-effect waves-light font-size-15"
                      onClick={() => {
                        setredirect_alert(false)
                        if (redirect)
                          if (playing) {
                            console.log("playing")
                            stopAudio()
                          }
                        onRedeemAtAppClicked()
                      }}
                    >
                      {props.t("Bring me to the app")}
                    </button>
                  </Row>
                  <Row className="px-3 py-2">
                    <button
                      className="btn btn-light waves-effect waves-light font-size-15"
                      onClick={() => {
                        setredirect_alert(false)
                      }}
                    >
                      {props.t("Cancel")}
                    </button>
                  </Row>
                </React.Fragment>
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: isWechatBrowser ? "0px" : "56px",
                  backgroundColor:
                    orderData &&
                    orderData.payment_status == "Paid" &&
                    orderData.order_status != "Gifted" &&
                    !isWechatBrowser
                      ? "#F5F5F5"
                      : "white",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    {!isWechatBrowser && (
                      <Row
                        className="m-0 w-100"
                        style={{
                          height: "56px",
                          backgroundColor: "#009FE2",
                          position: "fixed",
                          top: 0,
                          zIndex: 1030,
                          maxWidth: "480px",
                        }}
                      >
                        <Col xs={2} className="ps-0">
                          {/* <Link to="/categories"> */}
                          {/* <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button> */}
                          {/* </Link> */}
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {props.t("Ugift")}
                          </p>
                        </Col>
                        <Col xs={2} className="pe-0">
                          {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                        </Col>
                      </Row>
                    )}
                    {isWechatBrowser ? (
                      <Row>
                        <Col>
                          <UgiftEmptyState
                            image={emptyWechat}
                            title={props.t(
                              "Please browse this page using your phone's browser"
                            )}
                            link={null}
                            linkText={props.t("Back to Home")}
                          />
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col>
                          {orderData &&
                            orderData.payment_status == "Paid" &&
                            orderData.order_status != "Gifted" && (
                              <Card className="mb-2 shadow-none">
                                <Row className="p-3">
                                  <Col xs="auto" className="pe-0">
                                    {orderData.member_profile_picture ? (
                                      <div>
                                        <img
                                          src={orderData.member_profile_picture}
                                          className="rounded-circle avatar-sm"
                                          alt=""
                                          style={{
                                            maxWidth: "36px",
                                            maxHeight: "36px",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        className="avatar-sm"
                                        style={{
                                          maxWidth: "36px",
                                          maxHeight: "36px",
                                        }}
                                      >
                                        <span
                                          className={
                                            "avatar-title rounded-circle bg-primary text-white font-size-16"
                                          }
                                        >
                                          {orderData.member_name &&
                                            orderData.member_name.charAt(0)}
                                        </span>
                                      </div>
                                    )}
                                  </Col>
                                  <Col className="align-self-center">
                                    <span className="font-size-15 text-dark">
                                      {orderData.member_name +
                                        " " +
                                        props.t("sent you a card")}
                                    </span>
                                  </Col>
                                </Row>
                              </Card>
                            )}
                          {/* {animationPlaying && (
                          <Card
                            className="mb-0 shadow-none "
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <SequenceAnimator
                              duration={2000}
                              loop={false}
                              autoplay={false}
                              ref={animBackRef}
                            >
                              {sequence.map((data, index) => (
                                <CardImg
                                  top
                                  className="img-fluid"
                                  src={data.back}
                                  alt=""
                                  style={{
                                    aspectRatio: "3/2",
                                    objectFit: "cover",
                                    borderRadius: "14px",
                                  }}
                                />
                              ))}
                            </SequenceAnimator>
                            <SequenceAnimator
                              duration={2000}
                              loop={false}
                              autoplay={false}
                              ref={animRef}
                            >
                              {sequence.map((data, index) => (
                                <CardImg
                                  top
                                  className="img-fluid"
                                  src={data.front}
                                  alt=""
                                  style={{
                                    aspectRatio: "3/2",
                                    objectFit: "cover",
                                    borderRadius: "14px",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                  }}
                                />
                              ))}
                            </SequenceAnimator>
                          </Card>
                        )} */}
                          {orderData &&
                            // !animationPlaying &&
                            orderData.payment_status == "Paid" &&
                            orderData.order_status != "Gifted" &&
                            giftData &&
                            orderData.giftcard_id != "0" &&
                            (redeemed ? (
                              <Card
                                className="mb-3 shadow-none p-3"
                                style={{
                                  borderRadius: "0px",
                                  // width: "160px",
                                  // height: "196px",
                                  backgroundColor: "white",
                                  overflow: "hidden",
                                }}
                              >
                                <Card
                                  className="mb-0"
                                  style={{ overflow: "hidden" }}
                                >
                                  {giftData && (
                                    <CardImg
                                      top
                                      className="img-fluid"
                                      src={giftData.image}
                                      alt=""
                                      style={{
                                        aspectRatio: "3/2",
                                        // objectFit: "cover",
                                        borderRadius: "14px",
                                        zIndex: 500,
                                      }}
                                    />
                                  )}
                                  {giftEditableData &&
                                    giftEditableData
                                      .filter(data => {
                                        return data.type == "text"
                                      })
                                      .map((data, index) => (
                                        // <Input
                                        //   type="text"
                                        //   className="form-control font-size-15"
                                        //   id={"textInput-" + data.key}
                                        //   name={data.key}
                                        //   placeholder={data.placeholder}
                                        //   value={data.content}
                                        //   style={{
                                        //     borderRadius: "4px",
                                        //     border: "none",
                                        //     background: "none",
                                        //     position: "absolute",
                                        //     top: `calc(100% * ${data.ypos / 800})`,
                                        //     left: `calc(100% * ${
                                        //       data.xpos / 1200
                                        //     })`,
                                        //     width: `calc(100% * ${
                                        //       data.width / 1200
                                        //     })`,
                                        //     height: `calc(100% * ${
                                        //       data.height / 800
                                        //     })`,
                                        //     zIndex: 502,
                                        //   }}
                                        //   readOnly
                                        // />
                                        <span
                                          type="text"
                                          className="form-control font-size-15 p-0"
                                          id={"textInput-" + data.key}
                                          name={data.key}
                                          placeholder={data.placeholder}
                                          value={data.content}
                                          style={{
                                            borderRadius: "4px",
                                            border: "none",
                                            background: "none",
                                            position: "absolute",
                                            top: `calc(100% * ${
                                              data.ypos / cardSize.height
                                            })`,
                                            left: `calc(100% * ${
                                              data.xpos / cardSize.width
                                            })`,
                                            width: `calc(100% * ${
                                              data.width / cardSize.width
                                            })`,
                                            height: `calc(100% * ${
                                              data.height / cardSize.height
                                            })`,
                                            zIndex: 502,
                                          }}
                                        >
                                          {data.content}
                                        </span>
                                      ))}
                                  {giftEditableData &&
                                    giftEditableData
                                      .filter(data => {
                                        return data.type == "image"
                                      })
                                      .map(
                                        (data, index) =>
                                          data.content && (
                                            <div>
                                              <img
                                                src={data.content}
                                                id={"imgPreview-" + data.key}
                                                name={data.key}
                                                style={{
                                                  position: "absolute",
                                                  top: `calc(100% * ${
                                                    data.ypos / cardSize.height
                                                  })`,
                                                  left: `calc(100% * ${
                                                    data.xpos / cardSize.width
                                                  })`,
                                                  width: `calc(100% * ${
                                                    data.width / cardSize.width
                                                  })`,
                                                  height: `calc(100% * ${
                                                    data.height /
                                                    cardSize.height
                                                  })`,
                                                  // objectFit: "scale-down",
                                                  objectFit: "cover",
                                                  zIndex: 499,
                                                }}
                                              />
                                            </div>
                                          )
                                      )}
                                  {giftEditableData &&
                                    giftEditableData
                                      .filter(data => {
                                        return data.type == "sticker"
                                      })
                                      .map(
                                        (data, index) =>
                                          data.content && (
                                            <div>
                                              <img
                                                src={data.content}
                                                id={"sticker-" + data.key}
                                                name={data.key}
                                                style={{
                                                  position: "absolute",
                                                  top: `calc(100% * ${
                                                    data.ypos / cardSize.y
                                                  } * ${
                                                    cardSize.innerHeight /
                                                    cardSize.height
                                                  } + 10px)`,
                                                  // left: `calc(100% * ${
                                                  //   data.xpos / cardSize.x
                                                  // } + 100% * ${
                                                  //   6 / cardSize.width
                                                  // })`,
                                                  left: `calc(100% * ${
                                                    data.xpos / cardSize.x
                                                  } * ${
                                                    cardSize.innerWidth /
                                                    cardSize.width
                                                  } + 6px)`,
                                                  width: `calc(100% * ${
                                                    data.size == "s"
                                                      ? 1 / cardSize.x
                                                      : data.size == "m"
                                                      ? 1.5 / cardSize.x
                                                      : 2 / cardSize.x
                                                  }* ${
                                                    cardSize.innerWidth /
                                                    cardSize.width
                                                  } )`,
                                                  height: `calc(100% * ${
                                                    data.size == "s"
                                                      ? 1 / cardSize.y
                                                      : data.size == "m"
                                                      ? 1.5 / cardSize.y
                                                      : 2 / cardSize.y
                                                  }* ${
                                                    cardSize.innerHeight /
                                                    cardSize.height
                                                  })`,
                                                  // objectFit: "scale-down",
                                                  objectFit: "cover",
                                                  zIndex: 505,
                                                }}
                                              />
                                            </div>
                                          )
                                      )}
                                  {giftEditableData &&
                                    giftEditableData
                                      .filter(data => {
                                        return data.type == "custom_text"
                                      })
                                      .map((data, index) => (
                                        <span
                                          type="text"
                                          className="form-control p-0"
                                          id={"customText-" + data.key}
                                          name={data.key}
                                          placeholder={data.placeholder}
                                          value={data.content}
                                          style={{
                                            borderRadius: "4px",
                                            border: "none",
                                            background: "none",
                                            position: "absolute",
                                            fontFamily: data.fontfamily,
                                            color: data.fontcolor,
                                            top: `calc(100% * ${
                                              data.ypos / cardSize.y
                                            } + 10px)`,
                                            left: `calc(100% * ${
                                              data.xpos / cardSize.x
                                            } + 10px)`,
                                            width: `calc(100% * ${
                                              data.width / cardSize.width
                                            })`,
                                            height: `calc(100% * ${
                                              data.height / cardSize.height
                                            })`,
                                            fontSize: data.fontsize + "px",
                                            zIndex: 502,
                                          }}
                                        >
                                          {data.content}
                                        </span>
                                      ))}
                                </Card>
                              </Card>
                            ) : (
                              <Card
                                className="mb-3 shadow-none p-3"
                                style={{
                                  borderRadius: "0px",
                                  // width: "160px",
                                  // height: "196px",
                                  backgroundColor: "white",
                                }}
                                onClick={() => {
                                  // setRedeemed(true)
                                  setAnimationPlaying(true)
                                  // toggle()
                                  if (
                                    giftEditableData &&
                                    giftEditableData.filter(data => {
                                      return data.type == "music"
                                    }).length > 0
                                  ) {
                                    var songIndex = giftEditableData.filter(
                                      data => {
                                        return data.type == "music"
                                      }
                                    )[0].content

                                    if (songIndex != "" && musicData)
                                      updateAudio(
                                        musicData.filter(
                                          data => data.id == songIndex
                                        )[0].url
                                      )
                                  }

                                  console.log(
                                    "onclick",
                                    animRef.current.state.frame
                                  )
                                  if (animRef.current.state.frame != 0) {
                                    console.log("reset")
                                    animRef.current.reset()
                                  } else {
                                    console.log("start")
                                    animRef.current.start()
                                  }

                                  if (animBackRef.current.state.frame != 0)
                                    animBackRef.current.reset()
                                  else animBackRef.current.start()

                                  if (animCardRef.current.state.frame != 0)
                                    animCardRef.current.reset()
                                  else animCardRef.current.start()
                                }}
                              >
                                <CardImg
                                  top
                                  className="img-fluid"
                                  src={cardBg}
                                  alt=""
                                  style={{
                                    aspectRatio: "3/2",
                                    objectFit: "cover",
                                    borderRadius: "14px",
                                  }}
                                />
                                <SequenceAnimator
                                  duration={1700}
                                  loop={false}
                                  autoplay={false}
                                  ref={animBackRef}
                                >
                                  {sequence.map((data, index) => (
                                    <CardImg
                                      top
                                      className="img-fluid"
                                      src={data.back}
                                      alt=""
                                      style={{
                                        aspectRatio: "3/2",
                                        objectFit: "cover",
                                        borderRadius: "14px",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 499,
                                      }}
                                    />
                                  ))}
                                </SequenceAnimator>
                                <SequenceAnimator
                                  duration={1700}
                                  loop={false}
                                  autoplay={false}
                                  ref={animCardRef}
                                  onSequenceEnd={() => {
                                    setRedeemed(true)
                                  }}
                                >
                                  {sequence.map((data, index) => (
                                    <CardImg
                                      top
                                      className="img-fluid"
                                      src={data.showed ? giftData.image : back0}
                                      alt=""
                                      style={{
                                        aspectRatio: "3/2",
                                        objectFit: "cover",
                                        borderRadius: "14px",
                                        position: "absolute",
                                        top: data.top,
                                        left: data.left,
                                        width: data.width,
                                        zIndex: 500,
                                      }}
                                    />
                                  ))}
                                </SequenceAnimator>
                                <SequenceAnimator
                                  duration={1700}
                                  loop={false}
                                  autoplay={false}
                                  ref={animRef}
                                  onSequenceEnd={() => {
                                    setRedeemed(true)
                                  }}
                                >
                                  {sequence.map((data, index) => (
                                    <CardImg
                                      top
                                      className="img-fluid"
                                      src={data.front}
                                      alt=""
                                      style={{
                                        aspectRatio: "3/2",
                                        objectFit: "cover",
                                        borderRadius: "14px",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 501,
                                      }}
                                    />
                                  ))}
                                </SequenceAnimator>
                              </Card>
                              // <Card
                              //   className="mb-0 shadow-none p-3"
                              //   style={{
                              //     borderRadius: "0px",
                              //     // width: "160px",
                              //     // height: "196px",
                              //     backgroundColor: "white",
                              //   }}
                              //   onClick={() => {
                              //     // setRedeemed(true)
                              //     setAnimationPlaying(true)
                              //     // toggle()
                              //     if (
                              //       giftEditableData &&
                              //       giftEditableData.filter(data => {
                              //         return data.type == "music"
                              //       }).length > 0
                              //     ) {
                              //       var songIndex = giftEditableData.filter(
                              //         data => {
                              //           return data.type == "music"
                              //         }
                              //       )[0].content

                              //       if (songIndex != "")
                              //         updateAudio(
                              //           dummySong.filter(
                              //             data => data.id == songIndex
                              //           )[0].url
                              //         )
                              //     }

                              //     console.log(
                              //       "onclick",
                              //       animRef.current.state.frame
                              //     )
                              //     if (animRef.current.state.frame != 0) {
                              //       console.log("reset")
                              //       animRef.current.reset()
                              //     } else {
                              //       console.log("start")
                              //       animRef.current.start()
                              //     }

                              //     if (animBackRef.current.state.frame != 0)
                              //       animBackRef.current.reset()
                              //     else animBackRef.current.start()
                              //   }}
                              // >
                              //   <CardImg
                              //     top
                              //     className="img-fluid"
                              //     src={receiveCard}
                              //     alt=""
                              //     style={{
                              //       aspectRatio: "3/2",
                              //       objectFit: "cover",
                              //       borderRadius: "14px",
                              //     }}
                              //   />
                              // </Card>
                            ))}
                          {orderData &&
                            orderData.payment_status == "Paid" &&
                            orderData.order_status != "Gifted" &&
                            giftData &&
                            orderData.giftcard_id != "0" && (
                              <div>
                                {giftEditableData &&
                                  giftEditableData
                                    .filter(data => {
                                      return data.type == "message"
                                    })
                                    .map(
                                      (data, index) =>
                                        data.content != "" && (
                                          <div>
                                            <Row className="px-3 mb-3">
                                              <Col>
                                                <span
                                                  className="font-size-20 text-dark"
                                                  style={{ fontWeight: 500 }}
                                                >
                                                  {props.t("Message")}
                                                </span>
                                              </Col>
                                            </Row>
                                            <Row className="mx-0 mb-3">
                                              <Col className="px-3">
                                                <Card
                                                  className="mb-0 shadow-none p-3"
                                                  style={{
                                                    // borderRadius: "0px",
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  <Row className="">
                                                    <Col>
                                                      <span className="font-size-15 text-dark">
                                                        {data.content}
                                                      </span>
                                                    </Col>
                                                  </Row>
                                                </Card>
                                              </Col>
                                            </Row>
                                          </div>
                                        )
                                    )}
                                {giftEditableData &&
                                  musicData &&
                                  giftEditableData
                                    .filter(data => {
                                      return data.type == "music"
                                    })
                                    .map(
                                      (data, index) =>
                                        data.content != "" && (
                                          <Row className="m-0 mb-3">
                                            <Col>
                                              <Row className="px-3">
                                                <button
                                                  className="btn btn-outline-light mt-0 font-size-18 bg-white text-dark"
                                                  onClick={toggle}
                                                >
                                                  <span className="align-middle">
                                                    {playing ? (
                                                      <i className="bx bx-volume-full align-middle font-size-22 me-2" />
                                                    ) : (
                                                      <i className="bx bx-volume-mute align-middle font-size-22 me-2" />
                                                    )}{" "}
                                                    {data.content &&
                                                      musicData.filter(
                                                        value =>
                                                          value.id ==
                                                          data.content
                                                      ).length > 0 &&
                                                      musicData.filter(
                                                        value =>
                                                          value.id ==
                                                          data.content
                                                      )[0].name}
                                                  </span>
                                                </button>
                                              </Row>
                                            </Col>
                                          </Row>
                                        )
                                    )}
                              </div>
                            )}
                          {/* {orderData &&
                          orderData.payment_status == "Paid" &&
                          orderData.order_status != "Gifted" &&
                          giftData && (
                            <Row className="m-0">
                              <Col>
                                <Row className="px-3">
                                  <button
                                    className="btn btn-outline-dark mt-0 font-size-18"
                                    onClick={toggle}
                                  >
                                    {playing ? (
                                      <span className="align-middle">
                                        <i className="bx bx-volume-full align-middle font-size-22 me-2" />{" "}
                                        Song Name
                                      </span>
                                    ) : (
                                      <span className="align-middle">
                                        <i className="bx bx-volume-mute align-middle font-size-22 me-2" />{" "}
                                        Song Name
                                      </span>
                                    )}
                                  </button>
                                </Row>
                              </Col>
                            </Row>
                          )} */}
                          {orderData &&
                            orderData &&
                            orderData.payment_status == "Paid" &&
                            orderData.order_status != "Gifted" &&
                            orderData.products.map((data, index) => (
                              <Card
                                className="mb-0 p-3 shadow-none"
                                style={{
                                  borderRadius: "0px",
                                  // width: "160px",
                                  // height: "196px",
                                  backgroundColor: "white",
                                }}
                              >
                                <Row>
                                  <Col xs="auto">
                                    <img
                                      src={data.image}
                                      className="avatar-lg"
                                      alt=""
                                      style={{
                                        borderRadius: "8px",
                                        maxWidth: "72px",
                                        maxHeight: "72px",
                                      }}
                                    />
                                  </Col>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <strong>
                                          <span
                                            className="font-size-15 text-dark"
                                            style={{ fontWeight: 700 }}
                                          >
                                            {data.product_name}
                                          </span>
                                        </strong>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                        <span className="font-size-15 text-secondary">
                                          {props.t("Qty") +
                                            ": " +
                                            data.quantity}
                                        </span>
                                      </Col>
                                      <Col className="text-end">
                                        <span className="font-size-15 text-secondary">
                                          {/* {data.currency_code +
                                            " " +
                                            data.amount} */}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Card>
                            ))}
                          {orderData &&
                            orderData.payment_status == "Paid" &&
                            orderData.order_status == "Gifted" && (
                              <UgiftEmptyState
                                image={emptyImage}
                                title={
                                  props.t("Giftcard redeemed by") +
                                  " " +
                                  orderData.recipient_name
                                }
                                link={"/home"}
                                linkText={props.t("Back to Home")}
                              />
                            )}
                        </Col>
                      </Row>
                    )}
                    {!isWechatBrowser && redeemed && (
                      <Row
                        className="m-0 w-100"
                        style={{
                          height: "76px",
                          backgroundColor: "#ffffff",
                          position: "fixed",
                          bottom: 0,
                          zIndex: 1030,
                          maxWidth: "480px",
                          boxShadow: "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                        }}
                      >
                        <Col className="h-100 p-0">
                          <Card body className="mb-0 p-3">
                            <button
                              className="btn btn-danger waves-effect waves-light font-size-18"
                              // style={{ height: "42px" }}
                              onClick={() => {
                                uid
                                  ? onClickRedeemOrder()
                                  : onRedirectNotLogin()
                              }}
                            >
                              {props.t("Redeem")}
                            </button>
                          </Card>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(CardShare)

CardShare.propTypes = {
  t: PropTypes.any,
}
